module.exports = __webpack_public_path__ + "img/magento-services-integration@2x.47dced96.jpg";